import React, { useState } from "react";
import { sendPasswordResetEmail } from "../../utils";

interface ForgotPasswordProps {
  onBackToLogin: () => void;
  onClose: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  onBackToLogin,
  onClose,
}) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setError("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setIsLoading(true);
    setError(null);

    const result = await sendPasswordResetEmail(email);
    setIsLoading(false);

    if (result.success) {
      setEmailSent(true);
    } else {
      setError(result.error);
    }
  };

  if (emailSent) {
    return (
      <div className="login-modal-inner">
        <div className="main-form-login">
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h2 style={{ color: "#fff", marginBottom: "15px" }}>
              Check Your Email
            </h2>
            <p style={{ color: "#fff", marginBottom: "10px" }}>
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p style={{ color: "#fff", fontSize: "14px" }}>
              Please check your email and follow the instructions to reset your
              password.
            </p>
          </div>
          <div className="form-login-inner">
            <div className="para-parent para-parent-btn">
              <button onClick={onBackToLogin} style={{ cursor: "pointer" }}>
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-modal-inner">
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2 style={{ color: "#fff", marginBottom: "15px" }}>
          Reset Your Password
        </h2>
        <p style={{ color: "#fff", fontSize: "14px" }}>
          Enter your email address and we'll send you a link to reset your
          password.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="main-form-login">
          <label htmlFor="reset-email">Email Address</label>
          <input
            id="reset-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />

          {error && (
            <p className="login-error" style={{ color: "red" }}>
              {error}
            </p>
          )}

          <div
            className="form-login-inner"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <div
              className="para-parent para-parent-btn"
              style={{ width: "auto" }}
            >
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                  position: "relative",
                  width: "175px",
                }}
              >
                {isLoading ? (
                  <div className="spinner-container">
                    <div className="spinner"></div>
                  </div>
                ) : (
                  "Send Reset Link"
                )}
              </button>
            </div>

            <button
              type="button"
              onClick={onBackToLogin}
              style={{
                background: "none",
                border: "none",
                color: "#007aff",
                cursor: "pointer",
                textDecoration: "underline",
                fontSize: "14px",
              }}
            >
              Back to Login
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
